import styled from 'styled-components';

// Radius/padding/height match ContactInfoBox.style.ts and IdentityBox.tsx so
// the three cards line up in the Grid row.
export const IdentityBox = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e5e5e8;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
`;

export const InnerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.div`
  align-self: stretch;
  text-align: right;
  color: #a6aab5;
  font-size: 14px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  font-weight: 500;
`;

export const InfoSection = styled.div`
  display: flex;
  gap: 16px;
`;

export const InfoItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px;
`;

export const Label = styled.div`
  text-align: right;
  color: #60646e;
  font-size: 12px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  font-weight: 400;
  line-height: 20px;
`;

export const Value = styled.div`
  text-align: right;
  color: #1b1e24;
  font-size: 14px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  font-weight: 700;
  line-height: 20px;
`;

export const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  min-width: 0;
`;

// A national ID card is landscape, a letterhead introduction is portrait, and
// both land in this same slot. The frame keeps one fixed 4:3 box so the three
// cards in the row stay aligned, and the image is contained inside it — either
// orientation fits whole instead of being cropped by object-fit: cover.
export const IdImageFrame = styled.div`
  position: relative;
  width: 100%;
  max-width: 240px;
  aspect-ratio: 4 / 3;
  border-radius: 4px;
  border: 1px solid #e5e5e8;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
`;

// Same orange as the pending badge on app screenshots/logo, so "waiting for
// review" reads the same everywhere in the panel.
export const PendingBadge = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f59e0b;
  color: #fff;
  font-size: 11px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  font-weight: 600;
  line-height: 18px;
  pointer-events: none;
`;

export const PendingHint = styled.div`
  max-width: 240px;
  text-align: right;
  color: #8b90a0;
  font-size: 11px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  line-height: 18px;

  span {
    color: #1e88e5;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const IdImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  /* contain, not cover: never crop an ID or a letterhead. */
  object-fit: contain;
  display: block;
`;

// Stands in for IdImage when nothing has been uploaded. Rendering the <img>
// with an empty src drew the browser's broken-image icon instead, which read
// as a failure rather than as "nothing here yet".
export const IdImagePlaceholder = styled.div`
  width: 100%;
  max-width: 240px;
  aspect-ratio: 4 / 3;
  border-radius: 4px;
  border: 1px dashed #c9cdd6;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
  text-align: center;
  color: #8b90a0;
  font-size: 12px;
  font-family: 'IRANYekanXFaNum', sans-serif;
  line-height: 20px;
`;
